var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-icon',{staticClass:"icons8-edit",class:hover ? 'editIcon-icon-hover' : _vm.isActive ? 'editIcon-icon-active' : 'editIcon-icon',attrs:{"color":hover||_vm.isActive ? 'white' : 'warning',"size":"32"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }